module.exports = __webpack_public_path__ + "img/web_mockup.d1027976.png";